module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/P72LQq/tc-custom/9781614753414.jpg?1699130749558",
      "alt": "This image is the cover for the book Taylor's Ark"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Taylor's Ark\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("“Exciting . . . enjoyable space adventure . . . fun and well-crafted, with a heroine you’ll enjoy rooting for!” —"), _c('i', [_vm._v("Aboriginal Science Fiction")])]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Dr. Shona Taylor, a specialist in environmental medicine, discovers that a mysterious epidemic is killing the entire population of colony worlds. With the help of her special menagerie, including a cat that can detect environmental hazards, a dog whose system can synthesize vaccines, and an intelligent alien named Chirwl, Shona is determined to stop the epidemic in its tracks, but the people causing the epidemic have set her up to take the blame, spreading the rumor that she is an Angel of Death. Can she find a cure before the disease kills again and puts her and her menagerie in danger? ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jody Lynn Nye\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jody Lynn Nye lists her main career activity as \"spoiling cats.\" When not engaged upon this worthy occupation, she writes fantasy and science fiction books and short stories. Jody lives in the northwest suburbs of Chicago, with her husband Bill Fawcett, a writer, game designer, military historian and book packager, and a black cat, Jeremy. Jody and Bill are the fiction reviewers for Galaxy's Edge Magazine. Jody is on the net at jodylynnnye.com and mythadventures.net, on Facebook as Jody Lynn Nye, and Twitter @JodyLynnNye.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Word Fire Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0